import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "row", "checkbox", "selectAll", "selectedCount", "bulkActionButton"]

  connect() {
    this.applyFilter()
    this.updateSelectionState()
  }

  applyFilter() {
    const query = (this.hasFilterTarget ? this.filterTarget.value : "").trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      const search = (row.dataset.search || "").toLowerCase()
      row.hidden = query.length > 0 && !search.includes(query)

      if (row.hidden) {
        const checkbox = row.querySelector("input[type='checkbox']")
        if (checkbox) checkbox.checked = false
      }
    })

    this.updateSelectionState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.visibleCheckboxes.forEach((checkbox) => {
      checkbox.checked = checked
    })

    this.updateSelectionState()
  }

  updateSelectionState() {
    const visibleCheckboxes = this.visibleCheckboxes
    const checkedVisibleCheckboxes = visibleCheckboxes.filter((checkbox) => checkbox.checked)

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = visibleCheckboxes.length > 0 && checkedVisibleCheckboxes.length === visibleCheckboxes.length
      this.selectAllTarget.indeterminate = checkedVisibleCheckboxes.length > 0 && checkedVisibleCheckboxes.length < visibleCheckboxes.length
    }

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedVisibleCheckboxes.length > 0 ? `(${checkedVisibleCheckboxes.length} selected)` : ""
    }

    if (this.hasBulkActionButtonTarget) {
      this.bulkActionButtonTarget.disabled = checkedVisibleCheckboxes.length === 0
    }
  }

  get visibleCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.closest("tr").hidden)
  }
}
